/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StringSegment
 */
export interface StringSegment {
    /**
     * 
     * @type {string}
     * @memberof StringSegment
     */
    buffer?: string | null;
    /**
     * 
     * @type {number}
     * @memberof StringSegment
     */
    offset?: number;
    /**
     * 
     * @type {number}
     * @memberof StringSegment
     */
    length?: number;
    /**
     * 
     * @type {string}
     * @memberof StringSegment
     */
    value?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof StringSegment
     */
    hasValue?: boolean;
}

/**
 * Check if a given object implements the StringSegment interface.
 */
export function instanceOfStringSegment(value: object): value is StringSegment {
    return true;
}

export function StringSegmentFromJSON(json: any): StringSegment {
    return StringSegmentFromJSONTyped(json, false);
}

export function StringSegmentFromJSONTyped(json: any, ignoreDiscriminator: boolean): StringSegment {
    if (json == null) {
        return json;
    }
    return {
        
        'buffer': json['buffer'] == null ? undefined : json['buffer'],
        'offset': json['offset'] == null ? undefined : json['offset'],
        'length': json['length'] == null ? undefined : json['length'],
        'value': json['value'] == null ? undefined : json['value'],
        'hasValue': json['hasValue'] == null ? undefined : json['hasValue'],
    };
}

export function StringSegmentToJSON(json: any): StringSegment {
    return StringSegmentToJSONTyped(json, false);
}

export function StringSegmentToJSONTyped(value?: StringSegment | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'buffer': value['buffer'],
        'offset': value['offset'],
        'length': value['length'],
        'value': value['value'],
        'hasValue': value['hasValue'],
    };
}

